export abstract class DomainError extends Error {
  abstract readonly code: string;
  readonly params: Record<string, unknown>;
  readonly httpStatus: number;

  constructor(
    message: string,
    params: Record<string, unknown> = {},
    httpStatus = 500
  ) {
    super(message);
    this.name = this.constructor.name;
    this.params = params;
    this.httpStatus = httpStatus;
  }
}
